<template>
  <div class="place-qr">
    <PlaceQrCard :placeDetail="description" :publish="true" v-if="!loadingDescription"/>
  </div>
</template>

<script>
import PlaceQrCard from '@/components/PlaceQrCard.vue'

export default {
  name: 'PlaceQr',
  components: {
    PlaceQrCard
  },
  data () {
    return {
      loadingDescription: true,
      description: null,
      lang: 'th'
    }
  },
  mounted () {
    var self = this
    if ('lang' in self.$route.query) {
      self.lang = self.$route.query.lang
    }
    self.$i18n.locale = self.lang
    self.getDescription()
  },
  methods: {
    getDescription () {
      var self = this
      self.pp.getPromptpaiDescription(
        self.$route.params.id,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        (result) => {
          if (result.status.code === 200) {
            if (result.data.length > 0) {
              self.description = result.data[0]
              self.loadingDescription = false
            }
          } else if (result.status.code === 401) {
            console.log(result.status.text)
          } else if (result.status.code === 403) {
            console.log(result.status.text)
          } else if (result.status.code === 404) {
            console.log(result.status.text)
          } else {
            console.log(result.status.text)
          }
        }
      )
    }
  }
}
</script>

<style scoped>
  .place-qr {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaceQr.vue